/**
 * Splits string into an array of tokens used for a tokenised search. See {@link matchesTokenisedSearchString}.
 */
export const splitIntoSearchTokens = (s: string) => s?.split(/[^a-zA-Z0-9]+/);
